import Tabs from './Tabs.css';

export default {
	Tabs
};
